import api from "../axios/index"

export const login = (values) => {
    return api.post('/users/login',values);
}

export const logout = () => {
    return api.post('/users/logout');
}